import { trimEnd, get } from 'lodash';
import { getContentText } from '@wix/communities-universal/dist/src/services/editor-content-text';
import { getPostCover as _getPostCover, getPostVideoEmbedCover as _getPostVideoEmbedCover, } from '@wix/communities-universal/dist/src/services/get-post-cover';
import { POST_SEO_DESCRIPTION_MAXLENGTH } from '../../constants';
import { getRichContentPostVideoEmbedCover, getVideoUrl, isRichContent, limitLength, removeTrailingSlash, resizeThumbnail, } from '../../services';
import { getMultilingualQueryParam } from '../../services/get-multilingual-query-param';
export { getPostImageCover } from '@wix/communities-universal/dist/src/services/get-post-cover';
import { getRichContentText } from '../../services/get-rich-content-text';
import { getRichContentPostCover } from '../../services/post-cover-utils';
const getHelpers = (imageHost, videoHost) => ({
    resizeThumbnail: (pathname, width, height) => resizeThumbnail({ pathname, width, height, imageHost }),
    getVideoUrl: (pathname) => getVideoUrl({ pathname, videoHost }),
});
export const getPostCover = (post, imageHost, videoHost) => {
    var _a;
    const postContent = get(post, 'content', {});
    return imageHost && videoHost
        ? isRichContent(postContent)
            ? getRichContentPostCover(post, imageHost, videoHost)
            : _getPostCover(post, getHelpers(imageHost, videoHost))
        : (_a = post === null || post === void 0 ? void 0 : post.coverImage) !== null && _a !== void 0 ? _a : {};
};
export const getPostVideoEmbedCover = (post, imageHost, videoHost) => {
    const postContent = get(post, 'content', {});
    if (isRichContent(postContent)) {
        return getRichContentPostVideoEmbedCover(postContent, imageHost, videoHost);
    }
    return _getPostVideoEmbedCover(post, getHelpers(imageHost, videoHost));
};
export const getPostExcerpt = ({ content, excerpt }) => limitLength(excerpt ||
    (isRichContent(content)
        ? getRichContentText(content)
        : getContentText(content)), POST_SEO_DESCRIPTION_MAXLENGTH);
export const getPostSeoDescription = ({ seoDescription, content, excerpt }) => limitLength(seoDescription ||
    excerpt ||
    (isRichContent(content)
        ? getRichContentText(content)
        : getContentText(content, POST_SEO_DESCRIPTION_MAXLENGTH)), POST_SEO_DESCRIPTION_MAXLENGTH);
export const getPostAmpUrl = (postId, ampBaseUrl, postSlug) => {
    if (!ampBaseUrl || !postId) {
        return;
    }
    return `${removeTrailingSlash(ampBaseUrl)}/${removeTrailingSlash(postSlug)}`;
};
export const getCanonicalPostUrl = ({ post, postPageSectionUrl, customPostUrl, multilingual, }) => {
    if (customPostUrl) {
        const langParam = getMultilingualQueryParam(multilingual);
        return `${customPostUrl}${langParam ? langParam : ''}`;
    }
    if (post.url) {
        return `${post.url.base}${post.url.path}`;
    }
    if (post.canonicalUrl) {
        return post.canonicalUrl;
    }
    return `${trimEnd(postPageSectionUrl, '/')}/${post.slug}`;
};
//# sourceMappingURL=post-selectors.js.map